/* eslint-disable */ 
export const BASE_URL: string = 'https://newsapi.org/v2/everything';
export const API_KEY: string = 'b59c5dd74a814621b8d0f01d19404e1e';
export const IMAGE_PLACEHOLDER: string = 'https://via.placeholder.com/150';
